import { ChangelogPlatformType } from "@somewear/api";

export enum ChangelogAsyncStatus {
	INITIAL = "initial",
	LOADING = "loading",
	IDLE = "idle",
}

export const lastTimeViewedLatestEntry = "lastTimeViewedLatestEntry";

export const getPlatformMap = (isStaff: boolean = false) => [
	{
		label: "ATAK",
		key: "atak",
		value: ChangelogPlatformType.ATAK,
	},
	{
		label: "iOS",
		key: "ios",
		value: ChangelogPlatformType.IOS,
	},
	{
		label: "Web",
		key: "web",
		value: ChangelogPlatformType.WEB,
	},
	{
		label: "Firmware",
		key: "firmware",
		value: ChangelogPlatformType.FIRMWARE,
	},
	{
		label: "Beam",
		key: "beam",
		value: ChangelogPlatformType.BEAM,
	},
	...(isStaff
		? [
				{
					label: "Unreleased",
					key: "unreleased",
				},
			]
		: []),
];
